import { render, staticRenderFns } from "./cascadeRegion.vue?vue&type=template&id=2687ce56&scoped=true"
import script from "./cascadeRegion.vue?vue&type=script&lang=js"
export * from "./cascadeRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687ce56",
  null
  
)

export default component.exports